import React from "react";
import PropTypes from "prop-types";

import { Title, Control, Label, Input, Column, Box } from "rbx";
import { useAuthorization } from "../../../../components/Authorization";
import { useIsDispatcher } from "../../../../hooks";
import DriversAndMechanics from "../components/DriversAndMechanics";

import {
  SystemCodeSelect,
  StateSelect,
  PhoneNumberInput,
  BooleanInput
} from "../../../../components/inputs";

function Personal({ employee, editing, onChange, mechanicTypeRecIdRef }) {
  const MechanicAuth = useAuthorization(["ADMIN", "HR"]);
  const isDispatcher = useIsDispatcher();
  return (
    <React.Fragment>
      <Column.Group>
        <Column size={6}>
          <Box>
            <Title subtitle>Personal</Title>
            <Column.Group>
              <Column size={2}>
                <Control>
                  <Label>Employee Id</Label>
                  <Input
                    disabled
                    autocomplete="new"
                    name="EmployeeId"
                    readOnly={!editing}
                    type="text"
                    value={employee.EmployeeId}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={3}>
                <Control>
                  <Label>First Name</Label>
                  <Input
                    required
                    autocomplete="new"
                    name="FirstName"
                    readOnly={!editing}
                    type="text"
                    value={employee.FirstName}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={3}>
                <Control>
                  <Label>Middle Name</Label>
                  <Input
                    autocomplete="new"
                    name="MiddleName"
                    readOnly={!editing}
                    type="text"
                    value={employee.MiddleName}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={4}>
                <Control>
                  <Label>Last Name</Label>
                  <Input
                    required
                    autocomplete="new"
                    name="LastName"
                    readOnly={!editing}
                    type="text"
                    value={employee.LastName}
                    onChange={onChange}
                  />
                </Control>
              </Column>
            </Column.Group>
            <Column.Group>
              <Column size={3}>
                <Control>
                  <SystemCodeSelect
                    icon="users"
                    label="Ethnicity"
                    lookup={{ Category: "Employee", Code: "Ethnicity" }}
                    name="EthnicityRecIdRef"
                    readOnly={!editing}
                    value={employee.EthnicityRecIdRef}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={9}>
                <Control>
                  <Label>Address 1</Label>
                  <Input
                    autocomplete="new"
                    name="Address1"
                    readOnly={!editing}
                    type="text"
                    value={employee.Address1}
                    onChange={onChange}
                  />
                </Control>
              </Column>
            </Column.Group>
            <Column.Group>
              <Column size={6}>
                <Control>
                  <Label>Address 2</Label>
                  <Input
                    autocomplete="new"
                    name="Address2"
                    readOnly={!editing}
                    type="text"
                    value={employee.Address2}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={6}>
                <Control>
                  <Label>City</Label>
                  <Input
                    autocomplete="new"
                    name="City"
                    readOnly={!editing}
                    type="text"
                    value={employee.City}
                    onChange={onChange}
                  />
                </Control>
              </Column>
            </Column.Group>
            <Column.Group>
              <Column size={3}>
                <Control style={{ marginRight: "15px" }}>
                  <Label>State</Label>
                  <StateSelect
                    name="State"
                    readOnly={!editing}
                    value={employee.State}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={3}>
                <Control>
                  <Label>Zip</Label>
                  <Input
                    autocomplete="new"
                    name="ZipCode"
                    readOnly={!editing}
                    type="text"
                    value={employee.ZipCode}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={6}>
                <Control>
                  <Label>Country</Label>
                  <Input
                    autocomplete="new"
                    name="Country"
                    readOnly={!editing}
                    type="text"
                    value={employee.Country}
                    onChange={onChange}
                  />
                </Control>
              </Column>
            </Column.Group>
          </Box>
        </Column>
        <Column size={6}>
          <Box>
            <Title subtitle>Contact</Title>
            <Column.Group>
              <Column size={4}>
                <Control>
                  <Label>Home Phone #</Label>
                  <PhoneNumberInput
                    name="HomePhoneNo"
                    readOnly={!editing}
                    type="text"
                    value={employee.HomePhoneNo}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={4}>
                <Control>
                  <Label>Cell Phone #</Label>
                  <PhoneNumberInput
                    name="CellPhoneNo"
                    readOnly={!editing}
                    type="text"
                    value={employee.CellPhoneNo}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={4}>
                <Control>
                  <Label>Alternate Phone #</Label>
                  <PhoneNumberInput
                    name="AlternatePhoneNo"
                    readOnly={!editing}
                    type="text"
                    value={employee.AlternatePhoneNo}
                    onChange={onChange}
                  />
                </Control>
              </Column>
            </Column.Group>
            <Column.Group>
              <Column size={3}>
                <Control>
                  <SystemCodeSelect
                    icon="address-book"
                    label="Contact Preference"
                    lookup={{
                      Category: "Employee",
                      Code: "ContactPreference"
                    }}
                    name="ContactPreferenceRecIdRef"
                    readOnly={!editing}
                    value={employee.ContactPreferenceRecIdRef}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column narrow>
                <Control>
                  <Label>Shop Steward</Label>
                  <BooleanInput
                    name="ShopSteward"
                    readOnly={!editing}
                    value={employee.ShopSteward}
                    onChange={onChange}
                  />
                </Control>
              </Column>
            </Column.Group>
            <Column.Group>
              <Column size={4}>
                <Control>
                  <Label>Emergency Phone #</Label>
                  <PhoneNumberInput
                    name="EmergencyPhoneNo"
                    readOnly={!editing}
                    type="text"
                    value={employee.EmergencyPhoneNo}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={4}>
                <Control>
                  <Label>Emergency Contact</Label>
                  <Input
                    autocomplete="new"
                    name="EmergencyContact"
                    readOnly={!editing}
                    type="text"
                    value={employee.EmergencyContact}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={4}>
                <Control>
                  <Label>Emergency Relationship</Label>
                  <Input
                    autocomplete="new"
                    name="EmergencyRelationship"
                    readOnly={!editing}
                    type="text"
                    value={employee.EmergencyRelationship}
                    onChange={onChange}
                  />
                </Control>
              </Column>
            </Column.Group>
            <Column.Group>
              <Column size={4}>
                <Control>
                  <Label>Email 1</Label>
                  <Input
                    autocomplete="new"
                    name="Email1"
                    readOnly={!editing}
                    type="email"
                    value={employee.Email1}
                    onChange={onChange}
                  />
                </Control>
              </Column>
              <Column size={4}>
                <Control>
                  <Label>Email 2</Label>
                  <Input
                    autocomplete="new"
                    name="Email2"
                    readOnly={!editing}
                    type="email"
                    value={employee.Email2}
                    onChange={onChange}
                  />
                </Control>
              </Column>
            </Column.Group>
          </Box>
        </Column>
      </Column.Group>
      <DriversAndMechanics
        MechanicAuth={MechanicAuth}
        editing={editing}
        employee={employee}
        isDispatcher={isDispatcher}
        mechanicTypeRecIdRef={mechanicTypeRecIdRef}
        onChange={onChange}
      />
    </React.Fragment>
  );
}

Personal.propTypes = {
  onChange: PropTypes.func,
  employee: PropTypes.object,
  editing: PropTypes.bool,
  mechanicTypeRecIdRef: PropTypes.number
};
Personal.defaultProps = {
  employee: {}
};
export default Personal;
